// import { useState } from 'react';
import { useContext, useEffect, useRef } from 'react';
import airVetrans from '../../assets/airVetransPic.png';
import ims from '../../assets/imsPic.png';
import erp from '../../assets/phonein hand.avif';
import erpPharma from '../../assets/erpPharmaPic.png';
import airforce from '../../assets/vetran.avif';
import jk from '../../assets/jk latest.jpg';


import { ObserverContext } from '../../Contexts/ObserverContext';

function Startportfolio() {
   const ref = useRef();

   const { activeSection, setActiveSection } = useContext(ObserverContext);

   useEffect(() => {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          // set value in context for section = team.
          setActiveSection('work');
          console.log('this is updated section',activeSection)
        }
      });
      if (ref && ref.current) {
        observer.observe(ref.current);
      }
      return () => {
        observer.disconnect();
      };
    }, [ref]);

  return (
    // <p>This is Startportfolio Page</p>
    <section className="blog-section" id="work" ref={ref}>
   {/* <div className="container" style={{marginBottom:'50px'}}>
      <h2 className="wow fadeInDown" data-wow-delay="300ms" style={{visibility: "hidden", animationDelay: "300ms", animationName: "none",display:'flex', justifyContent:'center'}}>Recent Projects</h2>
      <p className="wow fadeInDown" data-wow-delay="300ms" style={{visibility: "hidden", animationDelay: "300ms", animationName: "none",display:'flex', justifyContent:'center'}}>Intelligent and Deligent team provide smart solutions </p>
   </div> */}
   <div className="container">
         <h1
          className="wow fadeInDown"
          data-wow-delay="300ms"
          style={{
            visibility: "hidden",
            animationDelay: "300ms",
            animationName: "none",
            textAlign: "center",
          }}
        >
          Our Projects – IT Solutions & Digital Transformation Success
        </h1>
         <p className="wow fadeInDown" data-wow-delay="300ms">
       At Access Infotech, we believe every project is an opportunity to transform the way businesses operate. Over the years, we have partnered with organizations across manufacturing, retail, education, and financial services to deliver tailored IT solutions — from ERP implementations to custom applications. Each project reflects our commitment to innovation, precision, and measurable business outcomes.
      </p>
        <h2
        className="wow fadeInDown"
        data-wow-delay="300ms"
        style={{
          visibility: "hidden",
          animationDelay: "300ms",
          animationName: "none",
          textAlign: "center",
        }}
      >
        Projects by Industry
      </h2>
        <h3
        className="wow fadeInDown"
        data-wow-delay="300ms"
        style={{
          visibility: "hidden",
          animationDelay: "300ms",
          animationName: "none",
          textAlign: "center",
        }}
      >
         Manufacturing & Supply Chain
      </h3>
       <p className="wow fadeInDown" data-wow-delay="300ms">
       We have supported manufacturers in streamlining production, inventory, and distribution through our AccessONE ERP solutions. From reducing downtime to improving resource planning, our projects in this sector demonstrate tangible cost savings and operational efficiency.
      </p>
        <h3
        className="wow fadeInDown"
        data-wow-delay="300ms"
        style={{
          visibility: "hidden",
          animationDelay: "300ms",
          animationName: "none",
          textAlign: "center",
        }}
      >
       Retail & Distribution
      </h3>
       <p className="wow fadeInDown" data-wow-delay="300ms">
     Retail businesses rely on speed and accuracy. Our projects here focus on point-of-sale integration, customer management, and real-time analytics — helping clients improve sales visibility and enhance customer experiences.
      </p>
        <h3
        className="wow fadeInDown"
        data-wow-delay="300ms"
        style={{
          visibility: "hidden",
          animationDelay: "300ms",
          animationName: "none",
          textAlign: "center",
        }}
      >
      Financial Services & Accounting
      </h3>
       <p className="wow fadeInDown" data-wow-delay="300ms">
         Our projects for financial clients emphasize data security, compliance, and automation. From custom dashboards to database administration services, these solutions simplify complex financial operations and ensure accuracy at scale.
      </p>
        <h3
        className="wow fadeInDown"
        data-wow-delay="300ms"
        style={{
          visibility: "hidden",
          animationDelay: "300ms",
          animationName: "none",
          textAlign: "center",
        }}
      >
    Education & Public Sector
      </h3>
         <p className="wow fadeInDown" data-wow-delay="300ms">
             We’ve developed and implemented IT solutions that improve administrative efficiency, digital learning platforms, and resource allocation for schools and public institutions.
      </p>
            <h3
        className="wow fadeInDown"
        data-wow-delay="300ms"
        style={{
          visibility: "hidden",
          animationDelay: "300ms",
          animationName: "none",
          textAlign: "center",
        }}
      >
    Why Our Projects Stand Out
      </h3>
      <ul className="wow fadeInDown" data-wow-delay="300ms" style={{ textAlign: "left", display: "inline-block" }}>
  <li>Industry-focused expertise across multiple domains.</li>
  <li>Proven methodologies ensuring smooth execution.</li>
  <li>Transparent reporting and measurable outcomes.</li>
  <li>Continuous support after project completion.</li>
</ul>

         {/* <p className="wow fadeInDown" data-wow-delay="300ms" style={{textAlign:"center"}}>
            Industry-focused expertise across multiple domains.
            Proven methodologies ensuring smooth execution.
Transparent reporting and measurable outcomes.
Continuous support after project completion.
      </p> */}
            <h3
        className="wow fadeInDown"
        data-wow-delay="300ms"
        style={{
          visibility: "hidden",
          animationDelay: "300ms",
          animationName: "none",
          textAlign: "center",
        }}
      >
    Start Your Next Project with Us
      </h3>
         <p className="wow fadeInDown" data-wow-delay="300ms" style={{textAlign:"center"}}>
         Ready to transform your business with tailored IT solutions? Get in touch with our team to discuss your requirements and start building success stories together.
      </p>
      <div className="row">
         
         
         <div className="d-none d-lg-block col-lg-6 col-md-12 col-sm-12 col-xs-12 left-text left-heading wow fadeInLeftBig" data-wow-delay="300ms" style={{visibility: 'hidden', animationDelay: '300ms', animationName: 'none'}}>
            <h2>Computerisation of Pension for Defence Services</h2>
            {/* <h4>Client Name<br></br> <br></br><b>Indian Air Force - Directorate of Air Veterans</b></h4> */}
            <a className="btn button btn-rounded btn-light-blue btn-hvr-light-blue" href="/read-more/airVetrans">
               Read Full Story
               <div className="btn-hvr-setting">
                  <ul className="btn-hvr-setting-inner">
                     <li className="btn-hvr-effect"></li>
                     <li className="btn-hvr-effect"></li>
                     <li className="btn-hvr-effect"></li>
                     <li className="btn-hvr-effect"></li>
                  </ul>
               </div>
            </a>
         </div>
         <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 wow fadeInRightBig" data-wow-delay="300ms" style={{visibility: 'hidden', animationDelay: '300ms', animationName: 'none'}}>
            <img src={airforce} alt="image"/>
         </div>
         <div className="d-lg-none col-lg-6 col-md-12 col-sm-12 col-xs-12 left-text left-heading wow fadeInLeftBig" data-wow-delay="300ms" style={{visibility: 'hidden', animationDelay: '300ms', animationName: 'none'}}>
            <h2 className='pt-5'>Computerisation of Pension for Air Veterans</h2>
            {/* <h4>Client Name<br></br> <br></br><b>Indian Air Force - Directorate of Air Veterans</b></h4> */}
            <a className="btn button btn-rounded btn-light-blue btn-hvr-light-blue" href="/read-more/airVetrans">
               Read Full Story
               <div className="btn-hvr-setting">
                  <ul className="btn-hvr-setting-inner">
                     <li className="btn-hvr-effect"></li>
                     <li className="btn-hvr-effect"></li>
                     <li className="btn-hvr-effect"></li>
                     <li className="btn-hvr-effect"></li>
                  </ul>
               </div>
            </a>
         </div>

         <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 right-text wow fadeInLeftBig" data-wow-delay="300ms" style={{visibility: 'hidden', animationDelay: '300ms', animationName: 'none'}}>
            <img src={jk} alt="image"/>
         </div>
         <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 right-text right-heading  wow fadeInRightBig" data-wow-delay="300ms" style={{visibility: 'hidden', animationDelay: '300ms', animationName: 'none'}}>
            <h2>Inventory Management System IMS</h2> 
            {/* <h4>Client Name <br></br><br></br><b>Police Headquarters Jammu & Kashmir, Jammu</b></h4> */}
            <a className="btn button btn-rounded btn-light-blue btn-hvr-light-blue" href="/read-more/ims">
               Read Full Story
               <div className="btn-hvr-setting">
                  <ul className="btn-hvr-setting-inner">
                     <li className="btn-hvr-effect"></li>
                     <li className="btn-hvr-effect"></li>
                     <li className="btn-hvr-effect"></li>
                     <li className="btn-hvr-effect"></li>
                  </ul>
               </div>
            </a>
         </div>


         <div className="d-none d-lg-block col-lg-6 col-md-12 col-sm-12 col-xs-12 left-text left-heading wow fadeInLeftBig" data-wow-delay="300ms" style={{visibility: 'hidden', animationDelay: '300ms', animationName: 'none' ,paddingTop:'80px'}}>
            <h2>ERP Solution on Mobile</h2>
            {/* <h4>Client Name <br></br><br></br><b>Access Infotech Pvt. Ltds</b></h4> */}
            <a className="btn button btn-rounded btn-light-blue btn-hvr-light-blue" href="/read-more/erp">
               Read Full Story
               <div className="btn-hvr-setting">
                  <ul className="btn-hvr-setting-inner">
                     <li className="btn-hvr-effect"></li>
                     <li className="btn-hvr-effect"></li>
                     <li className="btn-hvr-effect"></li>
                     <li className="btn-hvr-effect"></li>
                  </ul>
               </div>
            </a>
         </div>
         <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 wow fadeInRightBig" data-wow-delay="300ms" style={{visibility: 'hidden', animationDelay: '300ms', animationName: 'none',paddingTop:'80px'}}>
            <img src={erp} alt="image"/>
         </div>
         <div className="d-lg-none col-lg-6 col-md-12 col-sm-12 col-xs-12 left-text left-heading wow fadeInLeftBig" data-wow-delay="300ms" style={{visibility: 'hidden', animationDelay: '300ms', animationName: 'none'}}>
            <h2 className='pt-5'>ERP Solution on Mobile</h2>
            {/* <h4>Client Name <br></br><br></br><b>Access Infotech Pvt. Ltds</b></h4> */}
            <a className="btn button btn-rounded btn-light-blue btn-hvr-light-blue" href="/read-more/erp">
               Read Full Story
               <div className="btn-hvr-setting">
                  <ul className="btn-hvr-setting-inner">
                     <li className="btn-hvr-effect"></li>
                     <li className="btn-hvr-effect"></li>
                     <li className="btn-hvr-effect"></li>
                     <li className="btn-hvr-effect"></li>
                  </ul>
               </div>
            </a>
         </div>

         <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 pt-sm-4 pt-xl-5 right-text wow fadeInLeftBig" data-wow-delay="300ms" style={{visibility: 'hidden', animationDelay: '300ms', animationName: 'none'}}>
            <img src={erpPharma} alt="image"/>
         </div>
         <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 pt-xl-5 right-text right-heading  wow fadeInRightBig" data-wow-delay="300ms" style={{visibility: 'hidden', animationDelay: '300ms', animationName: 'none'}}>
            <h2 className='mt-sm-1'>ERP Solution for Pharmaceutical Company</h2> 
            {/* <h4>Client Name <br></br><br></br><b>Cipla Pvt. Ltd</b></h4> */}
            <a className="btn button btn-rounded btn-light-blue btn-hvr-light-blue" href="/read-more/erpPharma">
               Read Full Story
               <div className="btn-hvr-setting">
                  <ul className="btn-hvr-setting-inner">
                     <li className="btn-hvr-effect"></li>
                     <li className="btn-hvr-effect"></li>
                     <li className="btn-hvr-effect"></li>
                     <li className="btn-hvr-effect"></li>
                  </ul>
               </div>
            </a>
         </div>
    
      </div>
   </div>
</section>
  );
}

export default Startportfolio;